module.exports = __webpack_public_path__ + "static/media/img_loading_bob.290724be.gif";